import { render, staticRenderFns } from "./fence.vue?vue&type=template&id=97724d6c&scoped=true"
import script from "./fence.vue?vue&type=script&lang=js"
export * from "./fence.vue?vue&type=script&lang=js"
import style0 from "./fence.vue?vue&type=style&index=0&id=97724d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97724d6c",
  null
  
)

export default component.exports